import apiClient from "../http/apiClient";
import { REPORTS_ENDPOINTS } from "../http/endpoints";

export async function getProductsProfitReport(params = {}) {
  const response = await apiClient.get(REPORTS_ENDPOINTS.productsProfit, { params });
  return response.data;
}

export async function getSalesProfitReport(params = {}) {
  const response = await apiClient.get(REPORTS_ENDPOINTS.salesProfit, { params });
  return response.data;
}

export async function getSalesByDateReport(params = {}) {
  const response = await apiClient.get(REPORTS_ENDPOINTS.salesByDate, { params });
  return response.data;
}

export const reportsService = {
  getProductsProfitReport,
  getSalesProfitReport,
  getSalesByDateReport,
};

export default reportsService;
